import { createCollection, localOnlyCollectionOptions } from "@tanstack/react-db";
import { SmartViewRow } from "@/domains/tanstack-db/repositories/smart-views/schemas";
import { SMART_VIEWS_COLLECTION_ID } from "./constants";

export interface SmartViewLocalCollectionOptions {
  initialData?: Array<SmartViewRow>;
}

export const createSmartViewLocalCollection = (options: SmartViewLocalCollectionOptions = {}) =>
  createCollection(
    localOnlyCollectionOptions<SmartViewRow, string>({
      id: SMART_VIEWS_COLLECTION_ID,
      getKey: view => view.id,
      initialData: options.initialData,
    })
  );
